export const sit = {
  id: 'sit',
  state: 'sit',
  system: false,

  enter(ctx) {
    ctx.movement.stopWalk();
    ctx.stateTimer = ctx.getStateDuration('sit');
  },

  update(ctx, dt) {
    if (!ctx.movement.isGrounded()) {
      ctx.transition('fall');
      return;
    }
    ctx.stateTimer -= dt;
    if (ctx.stateTimer <= 0) ctx.transitionToNext();
  },

  exit() {},
};
